var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UpdateBook } from "Server/Commands/UpdateBook";
import { TextArea } from "react-vcomponents";
import { BaseComponentPlus } from "react-vextensions";
import { Observer, PageContainer } from "vwebapp-framework";
let NotesUI = class NotesUI extends BaseComponentPlus({}, {}) {
    render() {
        const { book } = this.props;
        if (book == null)
            return React.createElement("div", null, "Please select a book.");
        return (React.createElement(PageContainer, { preset: "full" },
            React.createElement(TextArea, { value: book.notes, delayChangeTillDefocus: true, style: { height: "100%", whiteSpace: "" }, onChange: val => {
                    new UpdateBook({ id: book._key, updates: { notes: val } }).Run();
                } })));
    }
};
NotesUI = __decorate([
    Observer
], NotesUI);
export { NotesUI };
